import { useState } from 'react';

const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // 'http://localhost:3000' ; //
console.log('KC_SERVICE:', KC_SERVICE);


function ForgotPassword() {

  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [step, setStep] = useState(1); // Step 1: Enter email, Step 2: Enter OTP and new password
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

    // Helper to generate 6-digit OTP
    function generateOtp() {
      console.log('Generating OTP');
      return Math.floor(100000 + Math.random() * 900000).toString();
    }

    const handleSendOtp = async () => {
    try {
      const generatedOtp = generateOtp();
      setOtp(generatedOtp);
      console.log('Generated OTP:', generatedOtp);

      // Disable the button and change its label to 'Please wait'
      const sendOtpButton = document.querySelector('button[name="sendOtpButton"]');
      if (sendOtpButton) {
        sendOtpButton.disabled = true;
        sendOtpButton.backgroundColor='gray';
        sendOtpButton.textContent = 'Sending OTP...';
      }

      const response = await fetch(KC_SERVICE + '/send-pwd-reset-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          to: email,
          otp: generatedOtp,
          subject: "OTP for password reset",
          body: `OTP for password reset for your Knowledgecheck.in user: ${generatedOtp}`
        })
      });

      // Re-enable the button and restore its label
      if (sendOtpButton) {
        sendOtpButton.disabled = false;
        sendOtpButton.textContent = 'Send OTP';
      }

      if (!response.ok) {
        const errorText = await response.text();
        console.log('Error response from send-pwd-reset-otp:', errorText);
        throw new Error(errorText || 'Failed to send OTP1. Please try again.');
      }
      setMessage('OTP sent to your email.');
      setStep(2);
    }
    catch (err) {
      setError(err.message);
    }
  };

  const handleResetPassword = async () => {
    try {
      // check if value entered in field otpfromuser matches otp state
      if (document.getElementsByName('otpfromuser')[0].value !== otp) {
          throw new Error('Invalid OTP. Please try again.');
      }
      else {
        setError('');
      }

      // call api updatePassword with parameters email and newPassword
      // Disable the button and change its label to 'Please wait'
      const resetButton = document.querySelector('button[name="resetPasswordButton"]');
      if (resetButton) {
        resetButton.disabled = true;
        resetButton.backgroundColor='gray';
        resetButton.textContent = 'Please wait...';
      }

      //const response =
      await fetch(KC_SERVICE + '/updatePassword', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          emailId: email,
          newPassword: newPassword
        })
      });

      // Re-enable the button and restore its label
      if (resetButton) {
        resetButton.disabled = false;
        resetButton.textContent = 'Reset Password';
      }

      setMessage('Password reset successfully. Navigating to login page .. ');
      setTimeout(() => {
        window.location.href = '/?pageName=Login';
      }, 5000);
      setStep(1);
      setEmail('');
      setOtp('');
      setNewPassword('');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ backgroundColor: 'white', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      {step === 1 && (
        <div>
          <h2>Forgot Password</h2>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => {
              const emailValue = e.target.value;
              setEmail(emailValue);
              // Simple email validation
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(emailValue)) {
                setError('Please enter a valid email address.');
              } else {
                setError('');
              }
            }}
            style={{ marginBottom: '10px', padding: '8px', width: '100%' }}
          />
          <button onClick={handleSendOtp} style={{ padding: '10px', backgroundColor: 'blue', color: 'white' }} name="sendOtpButton" disabled={!email || error}>
            Send OTP
          </button>
        </div>
      )}
      {step === 2 && (
        <div>
          <h2>Reset Password</h2>
          <input
            type="text"
            placeholder="Enter OTP"
            name="otpfromuser"
            style={{ marginBottom: '10px', padding: '8px', width: '100%' }}
          />
          <input
            type="password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{ marginBottom: '10px', padding: '8px', width: '100%' }}
          />
          <button onClick={handleResetPassword} style={{ padding: '10px', backgroundColor: 'blue', color: 'white' }} name="resetPasswordButton">
            Reset Password
          </button>
        </div>
      )}
      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}

export default ForgotPassword;